import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';

export default function withCheckId<P extends object>(WrappedComponent: React.FunctionComponent<P>, action: Function) {
  return function ComponentDecoratedWithCheckId(props: P) {
    const [wrappedComponentAviable, setWrappedComponentAviable] = useState(false);
    const ids = useSelector(selectors.documents.selectAllActiveDocumentsID);
    useEffect(() => {
      if (ids && ids.length > 0) {
        setWrappedComponentAviable(true);
      } else {
        action();
      }
    }, [ids]);
    return wrappedComponentAviable ? <WrappedComponent {...props} /> : null;
  };
}
